module.exports = __webpack_public_path__ + "media/images/site/junior-girl-reading-book-in-studio-ad8428b0db73a85ee3d7ce35c200d778.jpg";